import { render, staticRenderFns } from "./aiRecord.vue?vue&type=template&id=31f9a0e0&scoped=true&"
import script from "./aiRecord.vue?vue&type=script&lang=js&"
export * from "./aiRecord.vue?vue&type=script&lang=js&"
import style0 from "./aiRecord.vue?vue&type=style&index=0&id=31f9a0e0&lang=scss&scoped=true&"
import style1 from "./aiRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9a0e0",
  null
  
)

export default component.exports